import styled from 'styled-components';

export const Container = styled.div<any>`
  height: 5rem;
  width: 100%;
  border: 2px dashed #ccc8c5;
  border-radius: 3px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: 0;

  &:hover {
    background-color: #F2F1F1;
    border: 2px dashed #B3ADA7};
  }
`;

export const Input = styled.input<any>``;
